import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M13.351 13.3352H21.3378C21.3378 19.9228 15.361 25.1236 8.53238 23.7901C4.37929 22.9766 1.02486 19.6295 0.212878 15.4689C-1.11824 8.64123 3.96664 2.66705 10.6222 2.66705V10.6682C10.6356 12.1484 11.8868 13.3352 13.351 13.3352ZM16.0133 10.6682H24C24 4.77402 18.6223 0 13.2978 0V8.00114C13.2978 9.48135 14.549 10.6682 16.0133 10.6682Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
